import styled from "styled-components";
import theme from "../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const ExpandCollapseButton = styled.div`
  text-align: center;
  color: ${theme.colors.primaryStrong};
  font-size: 14px;
  background-color: #f0f3f4;
  padding: 5% 5%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

const CustomExpandCollapseButton = (props) => {
  return (
    <ExpandCollapseButton
      onClick={() => {
        props.toggleExpandCollapse(!props.isPanelExpanded);
      }}
    >
      {props.isPanelExpanded ? (
        <>
          Collapse Panel <FontAwesomeIcon icon={faAngleUp} />
        </>
      ) : (
        <>
          Expand Panel <FontAwesomeIcon icon={faAngleDown} />
        </>
      )}
    </ExpandCollapseButton>
  );
};

export default CustomExpandCollapseButton;
